export default ({ request }) => ({
  masterCustomerDevTrackingListApi(data) {
    return request({
      url: '/digitalCenter/customer/dev/tracking/list',
      method: 'post',
      data,
    })
  },
  masterCustomerDevTrackingDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/dev/tracking/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerTrackingDevDelApi(data) {
    return request({
      url: '/digitalCenter/customer/dev/tracking/del',
      method: 'post',
      data,
    })
  },

  masterCustomerDevTrackingLogListApi(data) {
    return request({
      url: '/digitalCenter/customer/dev/tracking/log/list',
      method: 'post',
      data,
    })
  },
  masterCustomerDevQuotationVersionListApi(data) {
    return request({
      url: '/digitalCenter/customer/dev/tracking/quotation/version/list',
      method: 'post',
      data,
    })
  },
  masterCustomerDevTrackingSendListApi(data) {
    return request({
      url: '/digitalCenter/customer/dev/tracking/send/list',
      method: 'post',
      data,
    })
  },
})
